import { z } from 'zod'
import { occasionIdSchema } from '@/schemas/occasion.schema'

export const productCategorySchema = z.enum([
  'buques',
  'vasos',
  'orquideas',
  'caixas',
  'maternidade',
  'para-ele',
  'presentes',
  'assinatura',
])

export type ProductCategory = z.infer<typeof productCategorySchema>

export const productSchema = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  category: productCategorySchema,
  priceInCents: z.number().int().positive(),
  shortStory: z.string().min(1),
  occasions: z.array(occasionIdSchema).min(1),
  imagePath: z.string().nullable(),
})

export type Product = z.infer<typeof productSchema>
